<template>
  <div class="pagination-container d-flex flex-row justify-content-between flex-wrap">
    <!-- PAGINATION -->
    <ul v-if="usePagination" class="d-flex pagination align-self-center mb-0">
      <li class="page-item page-item-previous" :class="{ 'disabled': !clickedPageValid(getPage - 1) }" @click="pageClickedHandler(getPage - 1)">
        <i class="page-link material-icons" v-if="usePaginationArrows">keyboard_arrow_left</i>
        <button class="page-link prev-button">{{ $t('message.pagination.previousPage') }}</button>
      </li>
      <li class="page-item"
          v-for="(page, i) in getPagesRange(getPage, getPageCount)"
          :key="i"
          :class="{ 'active': page === getPage}"
          @click="pageClickedHandler(page)">
        <button class="page-link page-button">{{ page }}</button>
      </li>
      <li class="page-item page-item-next" :class="{ 'disabled': !clickedPageValid(getPage + 1) }" @click="pageClickedHandler(getPage + 1)">
        <button class="page-link next-button">{{ $t('message.pagination.nextPage') }}</button>
        <i class="page-link material-icons" v-if="usePaginationArrows">keyboard_arrow_right</i>
      </li>
    </ul>
    <!-- ITEMS PER PAGE -->
      <div v-if="useItemsPerPage" class="d-flex flex-row flex-wrap align-items-center items-per-page mt-3 mt-sm-0">
        <div class="d-inline align-middle mr-2">{{ $t('message.pagination.itemsPerPage') }}</div>
        <div class="col-right mr-2 d-inline" role="group" :aria-label="$t('message.pagination.itemsPerPage')" >
          <div class="btn-group items-per-page-dropdown" role="group">
            <button
              class="value-display list-group-item col d-flex flex-row justify-content-between p-0 align-items-center"
              id="itemsPerPageDropdown" type="button" data-toggle="dropdown" aria-expanded="false">
              <div class="pl-2 d-flex align-items-center">
                {{ itemsPerPage }}
              </div>
              <div class="items-per-page-icon ecl-select__icon text-white">
                <i class="material-icons">keyboard_arrow_down</i>
              </div>
            </button>
            <ul class="dropdown-menu ec-ds-dropdown-items" aria-labelledby="itemsPerPageDropdown">
              <button
                class="dropdown-item"
                @click="setPageLimit(item)"
                v-for="(item, index) in defaultItemsPerPageOptions"
                :key="index">{{ item }}</button>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="showExport" class="d-flex align-items-center">
      <button @click="isExportOpen = true" class="export-btn">
        Export
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.5 1.5v8M4.5 7l3 3 3-3" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 11.5v1a1 1 0 001 1h9a1 1 0 001-1v-1" stroke="white" stroke-width="1.6" stroke-linecap="round" />
        </svg>
      </button>
      <ExportDropdown :open="isExportOpen" @update:open="val => isExportOpen = val" />
    </div>
    </div>
</template>

<script>
import ExportDropdown from './ExportDropdown.vue'
export default {
  name: 'pagination',
  components: { ExportDropdown },
  props: {
    itemsCount: {
      type: Number,
      default: () => 0,
    },
    itemsPerPage: {
      type: Number,
      default: () => 0,
    },
    getPage: {
      type: Number,
      default: () => 1,
    },
    getPageCount: {
      type: Number,
      default: () => 1,
    },
     showExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pagesDisplayed: [],
      usePagination: this.$env.routing.pagination.usePagination,
      usePaginationArrows: this.$env.routing.pagination.usePaginationArrows,
      useItemsPerPage: this.$env.routing.pagination.useItemsPerPage,
      defaultItemsPerPageOptions: this.$env.routing.pagination.defaultItemsPerPageOptions,
      isExportOpen: false,
    };
  },
  computed: {},
  methods: {
    /**
     * @description Determines displayed pagenumbers and delimiters in the pagination.
     * @param currentPage {number} The currently active page.
     * @param lastPage {number} The number of the last page (also the pageCount).
     * @returns {array}
     */
    getPagesRange(currentPage, lastPage) {
      const current = typeof currentPage === 'function' ? currentPage() : currentPage;
      const last = typeof lastPage === 'function' ? lastPage() : lastPage;

      const safeCurrent = Number.isInteger(current) ? current : 1;
      const safeLast = Number.isInteger(last) ? last : 1;

      const displayCount = Math.min(6, safeLast);
      const displayStart = Math.max(
        1,
        Math.min(safeLast - displayCount + 1, safeCurrent - Math.floor(displayCount / 2))
      );

      return [...Array(displayCount).keys()].map(i => displayStart + i);
    },
    setPageLimit(limit) {
      this.$emit('setPageLimit', limit);
      this.changePageTo(1, limit);
    },
    pageClickedHandler(page) {
  if (this.clickedPageValid(page)) {
    this.$emit('page-changed', page);
    this.changePageTo(page, this.itemsPerPage);
  }
},
    clickedPageValid(page) {
      return typeof page === 'number' && page > 0 && page <= this.getPageCount;
    },
    changePageTo(page, limit) {
      this.$router.replace({ query: Object.assign({}, this.$route.query, { page, limit }) }).catch(error => { console.error(error); });
      this.scrollTo(0, 0);
    },
    scrollTo(x, y) {
      window.scrollTo(x, y);
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.page-item {
  display: flex;

  &.disabled {
    color: rgba(0,0,0,0.7);
  }

  .page-link {
    line-height: normal;
  }
}

.items-per-page {
  display: inline;
  margin-left: auto;

  .items-per-page-dropdown {
    width: 100px;
    height: 48px;
  }

  .items-per-page-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 2.75rem;
    background-color: var(--primary);
    .material-icons {
      font-size: 30px;
    }
  }
}
.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: var(--primary);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 18px;
  font-size: 16px;
  font-weight: 450;
  cursor: pointer;
}

.export-btn:hover {
  background-color: #1648c0;
}
</style>
